import { adaptBillingSearchStatements } from '@components/StatementRowsCommon/adapters';
import { groupDisplayedStatementTotalsByCurrency } from '@components/StatementRowsCommon/helpers';

export const getBillingSearchStatementRows = (contacts = []) => {
    if (!Array.isArray(contacts) || contacts.length === 0) {
        return [];
    }

    const statementRows = [];

    for (const contact of contacts) {
        statementRows.push(...adaptBillingSearchStatements(contact?.Statements || []));
    }

    return statementRows;
};

export const groupBillingSearchTotalsByCurrency = (contacts, defaultCurrency) => {
    const statementRows = getBillingSearchStatementRows(contacts);
    return groupDisplayedStatementTotalsByCurrency(statementRows, defaultCurrency);
};
